import React from "react";

export const LineChart23 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={60} height={28} rx={1} fill="#F1F2F6" />

    <polyline
      points="57 8 45 16 34 12 23 19 16 6 3 22"
      fill="none"
      stroke="#0787C9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </g>
);
